import React from 'react'
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import { useLocation, useParams } from 'react-router-dom'
import styled from '@emotion/styled'
import { capitalize, LinearProgress } from '@mui/material'
import { H3 } from '../../../layouts/TextStyles'
import { topicApiSlice } from '../../../features/topic/topicSlice'
import Breadcrumb from '../../../components/Breadcrumb'
import TopicsTable from './components/TopicsTable'
import AddTopicDialog from './components/Dialogs/AddTopicDialog'
import { ui } from '../../../utils/uiTokens'

const TopicsPage = () => {
    const { state } = useLocation()
    const { formatMessage, locale } = useIntl()
    const { subjectId } = useParams()
    const { data: topics = [], isFetching } =
        topicApiSlice.useGetTopicsBySubjectQuery(+subjectId)
    const [deleteTopic, { isLoading: isDeleting }] =
        topicApiSlice.useDeleteTopicMutation()

    const handleDelete = async (id: number) => {
        try {
            await deleteTopic(id).unwrap()
            toast.success(formatMessage({ id: 'deletedSuccess' }))
        } catch (error) {}
    }

    return (
        <Wrapper>
            <Breadcrumb
                links={[
                    'Пәндер',
                    state?.subject?.[`title${capitalize(locale)}`],
                ]}
            />

            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'topics' })}</H3>
                    </Title>

                    <AddTopicDialog subjectId={+subjectId} />
                </Header>

                {(isFetching || isDeleting) && <LinearProgress />}

                <TopicsTable
                    topics={topics}
                    onDelete={handleDelete}
                />
            </Content>
        </Wrapper>
    )
}

export default TopicsPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`
const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: ${ui.card};
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
